Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.StageScaleMode = module.exports.default = {
	EXACT_FIT: "exactFit",
	NO_BORDER: "noBorder",
	NO_SCALE: "noScale",
	SHOW_ALL: "showAll"
};